export enum ValidationStatusEnum {
    over18 = "OK_VALIDATE_AGE_18",
    over16 = "OK_VALIDATE_AGE_16",
    notValidated = "NOT_OK_VALIDATEAG",
    awaiting = "AWAITING"
}